
import { useContext, createContext } from 'react';

// Define proper type for subscription data
export interface Subscription {
  has_active_subscription: boolean;
  subscription: {
    plan?: string;
    is_trial?: boolean;
    trial_ends_at?: string;
    current_period_end?: string;
    features?: string[]; // Ensure features is properly typed
  } | null;
}

export interface SubscriptionPlan {
  id: string;
  name: string;
  description: string;
  price_monthly: number;
  price_yearly: number;
  features: string[];
  is_trial: boolean;
}

// Define the context type
export interface SubscriptionContextType {
  subscription: Subscription;
  isLoading: boolean;
  subscriptionPlans: SubscriptionPlan[];
  refreshSubscription: () => Promise<void>;
}

// Create and export the context
export const SubscriptionContext = createContext<SubscriptionContextType | undefined>(undefined);

export function useSubscription(): SubscriptionContextType {
  const context = useContext(SubscriptionContext);
  
  if (context === undefined) {
    throw new Error('useSubscription must be used within a SubscriptionProvider');
  }
  
  return {
    subscription: context.subscription,
    isLoading: context.isLoading,
    subscriptionPlans: context.subscriptionPlans,
    refreshSubscription: context.refreshSubscription
  };
}
